import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const MenuIndicator = {
  init: function() {
    this.cacheSelectors();
    this.setVendors();
    this.bindEvents();
  },

  cacheSelectors: function() {
    this.aside = document.querySelector('.bar')
    this.sections = document.querySelectorAll('.content');
    this.navLinks = document.querySelectorAll('aside nav a');
  },

  setVendors: function() {
    gsap.registerPlugin(ScrollTrigger);
    
  },

  bindEvents: function() {
    const self = this;

    gsap.to(".content", {
      scrollTrigger: {
          trigger: this.aside,
          start: "top top",
          end: `top top`,
          endTrigger: this.sections[this.sections.length - 1],
          pin: true,
          markers: true,
      }
    })

    this.sections.forEach((section, index) => {
      ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: 'top bottom',
      onEnter: () => self.setActiveLink(index),
      onLeaveBack: () => self.setActiveLink(index - 1)
      });
  });
},

  setActiveLink: function(index) {
    this.navLinks.forEach((link, i) => {
      if (i === index) {
          link.style.fontWeight = 'bold';
      } else {
          link.style.fontWeight = 'normal';
      }
  });
  },
};
